"use strict";

import INVENTORY from './inventory.store';

const DEFAULT_INVENTORY = {
    "1 BHK": {
        "0": {
            "item_id": 86,
            "qualifiedName": "furniture.sofaSets",
            "quantity": 1
        },
        "1": {
            "item_id": 85,
            "qualifiedName": "furniture.tables",
            "quantity": 1
        },
        "2": {
            "item_id": 84,
            "qualifiedName": "furniture.chairs",
            "quantity": 2
        },
        "3": {
            "item_id": 83,
            "qualifiedName": "furniture.cots",
            "quantity": 1
        },
        "4": {
            "item_id": 82,
            "qualifiedName": "furniture.mattress",
            "quantity": 1
        },
        "5": {
            "item_id": 80,
            "qualifiedName": "electronics.tVs",
            "quantity": 1
        },
        "6": {
            "item_id": 79,
            "qualifiedName": "electronics.refrigerators",
            "quantity": 1
        },
        "7": {
            "item_id": 78,
            "qualifiedName": "electronics.washingMachines",
            "quantity": 1
        }
    },
    "2 BHK": {
        "0": {
            "item_id": 86,
            "qualifiedName": "furniture.sofaSets",
            "quantity": 1
        },
        "1": {
            "item_id": 85,
            "qualifiedName": "furniture.tables",
            "quantity": 2
        },
        "2": {
            "item_id": 84,
            "qualifiedName": "furniture.chairs",
            "quantity": 4
        },
        "3": {
            "item_id": 83,
            "qualifiedName": "furniture.cots",
            "quantity": 1
        },
        "4": {
            "item_id": 82,
            "qualifiedName": "furniture.mattress",
            "quantity": 1
        },
        "5": {
            "item_id": 80,
            "qualifiedName": "electronics.tVs",
            "quantity": 1
        },
        "6": {
            "item_id": 79,
            "qualifiedName": "electronics.refrigerators",
            "quantity": 1
        },
        "7": {
            "item_id": 78,
            "qualifiedName": "electronics.washingMachines",
            "quantity": 1
        }
    },
    "3 BHK": {
        "0": {
            "item_id": 86,
            "qualifiedName": "furniture.sofaSets",
            "quantity": 1
        },
        "1": {
            "item_id": 85,
            "qualifiedName": "furniture.tables",
            "quantity": 2
        },
        "2": {
            "item_id": 84,
            "qualifiedName": "furniture.chairs",
            "quantity": 4
        },
        "3": {
            "item_id": 83,
            "qualifiedName": "furniture.cots",
            "quantity": 2
        },
        "4": {
            "item_id": 82,
            "qualifiedName": "furniture.mattress",
            "quantity": 2
        },
        "5": {
            "item_id": 80,
            "qualifiedName": "electronics.tVs",
            "quantity": 1
        },
        "6": {
            "item_id": 79,
            "qualifiedName": "electronics.refrigerators",
            "quantity": 1
        },
        "7": {
            "item_id": 78,
            "qualifiedName": "electronics.washingMachines",
            "quantity": 1
        }
    },
    "A_BIG_HOUSE": {
        "0": {
            "item_id": 86,
            "qualifiedName": "furniture.sofaSets",
            "quantity": 1
        },
        "1": {
            "item_id": 85,
            "qualifiedName": "furniture.tables",
            "quantity": 3
        },
        "2": {
            "item_id": 84,
            "qualifiedName": "furniture.chairs",
            "quantity": 6
        },
        "3": {
            "item_id": 83,
            "qualifiedName": "furniture.cots",
            "quantity": 3
        },
        "4": {
            "item_id": 82,
            "qualifiedName": "furniture.mattress",
            "quantity": 3
        },
        "5": {
            "item_id": 81,
            "qualifiedName": "furniture.cupboards",
            "quantity": 1
        },
        "6": {
            "item_id": 80,
            "qualifiedName": "electronics.tVs",
            "quantity": 2
        },
        "7": {
            "item_id": 79,
            "qualifiedName": "electronics.refrigerators",
            "quantity": 1
        },
        "8": {
            "item_id": 78,
            "qualifiedName": "electronics.washingMachines",
            "quantity": 1
        },
        "9": {
            "item_id": 73,
            "qualifiedName": "others.homeAppliances",
            "quantity": 1,
            "order_item_details": {
                "0": {
                    "name": "vacuumCleaners",
                    "qualifiedName": "others.homeAppliances.vacuumCleaners",
                    "displayName": "Vacuum cleaners",
                    "description": "Vacuum cleaner",
                    "identifier": 391,
                    "item_id": 73,
                    "version": "1c",
                    "cubic_feet": 8,
                    "is_include": true,
                    "quantity": 1
                }
            }
        }
    }
};

class InventoryHierarchy {
    /*@ngInject*/
    constructor() {
        "ngInject";
    }

    /**
     * Return the child nodes for specified hierarchy
     * @param hierarchy - ['furniture', 'chairs', 'rocking']
     * @returns []
     */
    getChildrenFor = _.memoize((qualifiedName) => {
        if (_.isEmpty(qualifiedName)) {
            return [];
        }

        let hierarchy  = qualifiedName.split('.'),
            rootName   = hierarchy[0],
            qualifiers = hierarchy.slice(1);

        let item = _.find(INVENTORY, {name: rootName});
        _.forEach(qualifiers, function (qualifier) {
            if (item && item.children) {
                item = _.find(item.children, {name: qualifier});
            }
        });

        let children =  _(item.children)
            .map((category) => _.omit(category, 'children'))
            .sortBy(category => category.score)
            .value();

        return children;
    })

    fetchDefaultItems(order, inventory) {
        const propertyType = order.property_type;

        if (_.isEmpty(order.order_items)) {
            return this.getDefaultInventoryFor(propertyType);
        }

        return order.order_items;
    }

    getDefaultInventoryFor(propertyType) {
        switch (propertyType) {
            case '1 BHK':
                return _.cloneDeep(DEFAULT_INVENTORY['1 BHK']);
            case '2 BHK':
                return _.cloneDeep(DEFAULT_INVENTORY['2 BHK']);
            case '3 BHK':
                return _.cloneDeep(DEFAULT_INVENTORY['3 BHK']);
            default:
                const noDefaults = ['VEHICLE', 'ITEM'];
                if (_.contains(noDefaults, propertyType)) {
                    return [];
                }
                return _.cloneDeep(DEFAULT_INVENTORY['A_BIG_HOUSE']);
        }
    }

    getQualifiedNameFor(item) {
        let majorCategoryId = item.item_id,
            itemDetailId = item.identifier,
            majorCategories = _.flatten(_.pluck(INVENTORY, 'children')),
            exactQualifiedItem = _.find(majorCategories, {item_id: majorCategoryId, identifier: itemDetailId}),
            qualifiedItem = !exactQualifiedItem && _.find(majorCategories, {item_id: majorCategoryId});

        if (exactQualifiedItem) {
            return exactQualifiedItem.qualifiedName;
        }

        if (majorCategoryId && !itemDetailId) {
            return qualifiedItem ? qualifiedItem.qualifiedName : undefined;
        }

        qualifiedItem = this.getItemWithCategoryAndItemId(majorCategoryId, itemDetailId);
        return qualifiedItem ? qualifiedItem.qualifiedName : undefined;
    }

    getItemWithCategoryAndItemId(categoryId, itemId) {
        let majorCategories = _.flatten(_.pluck(INVENTORY, 'children')),
            majorCategory = _.find(majorCategories, {item_id: categoryId});

        if (!majorCategory) {
            return undefined;
        }

        let leafNodesInCategory = this.getLeafNodesIn(majorCategory);

        let itemSource = _.find(leafNodesInCategory, {identifier: itemId});

        return itemSource ? _.clone(itemSource) : undefined;
    }

    getLeafNodesIn(category) {
        return _(category.children)
        .map((child) => {
            if (child.children && child.children.length > 0) {
                return this.getLeafNodesIn(child);
            }
            return child;
        })
        .flatten()
        .value();
    }

    /**
     *
     * @param qualifiedName
     * @returns A copy of the item from INVENTORY that matches the provided qualified name
     */
    getItemWithQualifiedName(qualifiedName) {
        if (_.isEmpty(qualifiedName)) {
            return {};
        }

        let hierarchy  = qualifiedName.split('.'),
            rootName   = hierarchy[0],
            qualifiers = hierarchy.slice(1);

        let item = _.find(INVENTORY, {name: rootName});
        _.forEach(qualifiers, function (qualifier) {
            if (item && item.children) {
                item = _.find(item.children, {name: qualifier});
            }
        });

        return _(item).omit('children').clone();
    }

    getMiscellaneousRootItems() {
        let rootCategories = ['others.utility', 'others.homeAppliances', 'others.specialCareItems', 'others.funAndFitness'];
        return _.map(rootCategories, this.getItemWithQualifiedName);
    }

    getPrimaryRootItems() {
        let rootCategories = ['furniture', 'electronics', 'vehicle'];
        return _.map(rootCategories, this.getItemWithQualifiedName);
    }
}

export default InventoryHierarchy;


// WEBPACK FOOTER //
// ./client/app/common/inventory/inventory.hierarchy.js